import { getTradingTrialsStats } from "../../plugins/api-service";

const state = {
    stats: {
        active_trading_during_trial_ratio: null,
        upgrades_after_trial_ratio: null,
        upgrade_after_trial_with_active_trading_ratio: null,
    },
};

const getters = {
};

const mutations = {
    setStats: (state, result) => {
        state.stats.active_trading_during_trial_ratio = result.active_trading_during_trial_ratio;
        state.stats.upgrades_after_trial_ratio = result.upgrades_after_trial_ratio;
        state.stats.upgrade_after_trial_with_active_trading_ratio = result.upgrade_after_trial_with_active_trading_ratio;
    },
};

const actions = {
    getStats: async ({ commit }) => {
        try {
            const statsResult = await getTradingTrialsStats();
            if (statsResult?.success && statsResult.result) {
                commit('setStats', statsResult.result);
                return statsResult;
            }
        } catch (error) {
            let message = error;

            if (error.response && error.response.data) {
                message = error.response.data;
            }
            return message;
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
